exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ant-card-body .table-operator[data-v-02a31774]{\n  margin-bottom: 18px;\n}\n.anty-row-operator button[data-v-02a31774]{margin: 0 5px}\n.ant-btn-danger[data-v-02a31774]{background-color: #ffffff}z\n\n.ant-modal-cust-warp[data-v-02a31774]{height: 100%}\n.ant-modal-cust-warp .ant-modal-body[data-v-02a31774]{height:-webkit-calc(100% - 110px) !important;height:calc(100% - 110px) !important;overflow-y: auto}\n.ant-modal-cust-warp .ant-modal-content[data-v-02a31774]{height:90% !important;overflow-y: hidden}\n", ""]);

// exports
